import FileAnswerContent from '@app/src/components/FileAnswerContent'
import type { ResponseItem } from '@app/src/types/resourceExplorer'
import { Typography } from '@mui/material'
import React from 'react'
import { useIntl } from 'react-intl'
import { getResponseValueTypes } from '../../utils'
import CoordinateAnswerDisplay from './CoordinateAnswerDisplay'

export interface AnswerValueProps {
  item: ResponseItem
  questionType: string
  unitSymbol: string | null
}

const AnswerValue: React.FC<AnswerValueProps> = ({ item, questionType, unitSymbol }) => {
  const { formatMessage } = useIntl()
  const { displayAsOptions, selectedOptions, hasValue, displayAsFile, displayAsCoordinates } = getResponseValueTypes(
    questionType,
    item,
  )

  if (displayAsFile) {
    return <FileAnswerContent item={item} showExpiresAtText />
  }

  if (displayAsOptions) {
    if (selectedOptions?.length) {
      return <Typography>{selectedOptions?.join(', ')}</Typography>
    }
  }

  if (displayAsCoordinates) {
    return <CoordinateAnswerDisplay coordinates={item.coordinates ?? []} />
  }

  if (hasValue) {
    return (
      <Typography sx={{ wordBreak: 'break-word' }}>
        {item.answer || ''} {unitSymbol || ''}
      </Typography>
    )
  }

  return <Typography>{formatMessage({ id: 'reporting.noResponse' })}</Typography>
}

export default AnswerValue
